// main.js

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
    initPreloader();
    initScrollytelling();
    init360Viewer();
});

// --- Preloader ---
function initPreloader() {
    window.addEventListener('load', () => {
        const preloader = document.getElementById('preloader');
        setTimeout(() => {
            preloader.style.opacity = '0';
            setTimeout(() => {
                preloader.style.display = 'none';
                
                // Animate hero text on load
                gsap.from("#scrolly-text h1", { y: 50, opacity: 0, duration: 1, ease: "power3.out" });
                gsap.from("#scrolly-text p", { y: 30, opacity: 0, duration: 1, delay: 0.2, ease: "power3.out" });
            }, 500);
        }, 800); // Simulated minimum load time
    });
}

// --- Hero Scrollytelling ---
function initScrollytelling() {
    const canvas = document.getElementById("hero-scrolly-canvas");
    const context = canvas.getContext("2d");
    const loadingPlaceholder = document.getElementById("loading-placeholder");
    
    canvas.width = 1920;
    canvas.height = 1040;

    const frameCount = 192; // Frame count modified to sync with the new 203 webp extraction
    const currentFrame = index => (
        window.shopifyAssetUrl + (index + 1).toString().padStart(3, '0') + '.webp'
    );

    const images = [];
    const scrollyTellingInfo = {
        frame: 0
    };

    let loadedImages = 0;

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        // Fallback drawing if images aren't present
        img.onload = () => {
            loadedImages++;
            if (loadedImages === 1) {
                if (loadingPlaceholder) {
                    loadingPlaceholder.style.display = 'none';
                }
                renderScrolly();
            }
        };
        img.onerror = () => {
            loadedImages++; // Count as loaded to prevent stuck, will just draw blank
            if (loadedImages === 1) {
                if (loadingPlaceholder) {
                    loadingPlaceholder.innerText = "Imágenes no encontradas (Añadir a /assets/scrollytelling/)";
                }
            }
        }
        img.src = currentFrame(i);
        images.push(img);
    }

    gsap.to(scrollyTellingInfo, {
        frame: frameCount - 1,
        snap: "frame",
        ease: "none",
        scrollTrigger: {
            trigger: "#scrollytelling-section",
            start: "top top",
            end: "bottom bottom",
            scrub: 0.5,
        },
        onUpdate: renderScrolly
    });

    // Fade out text as we scroll down
    gsap.to("#scrolly-text", {
        opacity: 0,
        y: -100,
        ease: "none",
        scrollTrigger: {
            trigger: "#scrollytelling-section",
            start: "top top",
            end: "center center",
            scrub: true
        }
    });

    // Fade IN side manifesto
    gsap.fromTo("#side-manifesto", 
        { opacity: 0, x: 50 },
        { 
            opacity: 1, 
            x: 0, 
            ease: "power2.out",
            scrollTrigger: {
                trigger: "#scrollytelling-section",
                start: "30% top",
                end: "50% top",
                scrub: true
            }
        }
    );

    // Fade IN left stats
    gsap.fromTo("#left-stats", 
        { opacity: 0, x: -50 },
        { 
            opacity: 1, 
            x: 0, 
            ease: "power2.out",
            scrollTrigger: {
                trigger: "#scrollytelling-section",
                start: "30% top",
                end: "50% top",
                scrub: true
            }
        }
    );

    // Animate the counters when they fade in
    const statsObj = { pairs: 0, platforms: 0, tap: 0 };
    gsap.to(statsObj, {
        pairs: 5000,
        platforms: 5,
        tap: 1,
        duration: 2,
        ease: "power2.out",
        onUpdate: () => {
            const pairsEl = document.getElementById('stat-pairs');
            const platformsEl = document.getElementById('stat-platforms');
            const tapEl = document.getElementById('stat-tap');
            if (pairsEl) pairsEl.innerText = Math.floor(statsObj.pairs).toLocaleString();
            if (platformsEl) platformsEl.innerText = Math.floor(statsObj.platforms) + '+';
            if (tapEl) tapEl.innerText = Math.floor(statsObj.tap);
        },
        scrollTrigger: {
            trigger: "#scrollytelling-section",
            start: "35% top", // triggers slightly after fade starts
            toggleActions: "play none none none"
        }
    });

    // Fade out dark overlay to reveal the bright sequence when text disappears
    gsap.to("#hero-overlay", {
        opacity: 0,
        ease: "none",
        scrollTrigger: {
            trigger: "#scrollytelling-section",
            start: "top top",
            end: "center center",
            scrub: true
        }
    });

    function renderScrolly() {
        if(images[scrollyTellingInfo.frame] && images[scrollyTellingInfo.frame].complete && images[scrollyTellingInfo.frame].naturalWidth !== 0) {
            context.clearRect(0, 0, canvas.width, canvas.height);
            // Draw image covering the canvas
            const img = images[scrollyTellingInfo.frame];
            const scale = Math.max(canvas.width / img.width, canvas.height / img.height);
            const x = (canvas.width / 2) - (img.width / 2) * scale;
            const y = (canvas.height / 2) - (img.height / 2) * scale;
            context.drawImage(img, x, y, img.width * scale, img.height * scale);
        } else {
            // Draw placeholder rect if image missing
            context.fillStyle = "#000";
            context.fillRect(0, 0, canvas.width, canvas.height);
        }
    }
    
    // Handle resize
    window.addEventListener('resize', () => {
        // Adjust canvas internal resolution to match aspect ratio reasonably, keeping 1920x1040 as base
        renderScrolly();
    });
}

// --- Demo E-commerce 360 Viewer ---
function init360Viewer() {
    const viewerContainer = document.querySelector("#viewer-360-canvas").parentElement;
    const canvas = document.getElementById("viewer-360-canvas");
    const context = canvas.getContext("2d");
    const placeholder = document.getElementById("viewer-placeholder");

    canvas.width = 1200;
    canvas.height = 800;

    const frameCount = 54; // 54 frames for 360 rotation
    const currentFrame = index => (
        window.shopifyAssetUrl + 'ezgif-frame-' + (index + 1).toString().padStart(3, '0') + '.jpg'
    );

    const images = [];
    let state = {
        frame: 0
    };
    
    let loadedImages = 0;

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.onload = () => {
            loadedImages++;
            if (loadedImages === 1) {
                placeholder.style.display = 'none';
                render360();
            }
        };
        img.onerror = () => {
            loadedImages++;
            if (loadedImages === 1) {
                placeholder.innerText = "[Faltan assets en /assets/360-viewer/]";
            }
        }
        img.src = currentFrame(i);
        images.push(img);
    }

    function render360() {
        if(images[state.frame] && images[state.frame].complete && images[state.frame].naturalWidth !== 0) {
            context.clearRect(0, 0, canvas.width, canvas.height);
            // Draw image covering the canvas (no borders/frame)
            const img = images[state.frame];
            const scale = Math.max(canvas.width / img.width, canvas.height / img.height);
            const x = (canvas.width / 2) - (img.width / 2) * scale;
            const y = (canvas.height / 2) - (img.height / 2) * scale;
            context.drawImage(img, x, y, img.width * scale, img.height * scale);
        } else {
             // Draw placeholder
             context.fillStyle = "#1a1a1a";
             context.fillRect(0, 0, canvas.width, canvas.height);
        }
    }

    // Drag Interaction Logic
    let isDragging = false;
    let startX = 0;
    let frameOnInteractionStart = 0;
    
    // Auto Rotation Logic
    let isHovered = false;
    let lastAutoRotateTime = 0;
    let autoRotateAccumulator = 0;
    
    function autoRotate(currentTime) {
        if (!lastAutoRotateTime) lastAutoRotateTime = currentTime;
        const deltaTime = currentTime - lastAutoRotateTime;
        lastAutoRotateTime = currentTime;

        if (!isDragging) {
            autoRotateAccumulator += deltaTime;
            // Normal speed: 45ms per frame. Hover speed: 180ms per frame.
            const threshold = isHovered ? 180 : 45;
            
            if (autoRotateAccumulator > threshold) {
                // Increment frame
                state.frame = (state.frame + 1) % frameCount;
                render360();
                autoRotateAccumulator = 0;
            }
        }
        
        requestAnimationFrame(autoRotate);
    }
    
    requestAnimationFrame(autoRotate);
    
    // Hover Listeners
    viewerContainer.addEventListener('mouseenter', () => {
        isHovered = true;
    });

    viewerContainer.addEventListener('mouseleave', () => {
        isHovered = false;
    });
    
    // factor controls sensitivity
    const sensitivity = 5;

    viewerContainer.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        frameOnInteractionStart = state.frame;
    });

    window.addEventListener('mouseup', () => {
        isDragging = false;
    });

    window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        
        const deltaX = e.clientX - startX;
        // Calculate new frame based on horizontal movement
        let frameShift = Math.floor(deltaX / sensitivity);
        
        // Inverse interaction if needed, here right push increases frame
        let newFrame = (frameOnInteractionStart + frameShift) % frameCount;
        
        if (newFrame < 0) {
            newFrame = frameCount + newFrame; // wrap around
        }

        if (newFrame !== state.frame) {
            state.frame = newFrame;
            render360();
        }
    });

    // Touch support for mobile
    viewerContainer.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
        frameOnInteractionStart = state.frame;
    }, {passive: true});

    window.addEventListener('touchend', () => {
        isDragging = false;
    });

    window.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        
        const deltaX = e.touches[0].clientX - startX;
        let frameShift = Math.floor(deltaX / sensitivity);
        
        let newFrame = (frameOnInteractionStart + frameShift) % frameCount;
        if (newFrame < 0) {
            newFrame = frameCount + newFrame;
        }

        if (newFrame !== state.frame) {
            state.frame = newFrame;
            render360();
        }
    }, {passive: true});
}

// --- Top Ribbon & Header Scroll Logic ---
document.addEventListener("DOMContentLoaded", () => {
    const ribbon = document.getElementById('top-ribbon');
    const header = document.getElementById('main-header');
    
    if (window.headerLogicBound) return;
    window.headerLogicBound = true;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            if(ribbon) ribbon.style.transform = 'translateY(-100%)';
            if(header) {
                header.style.top = '1rem';
            }
        } else {
            if(ribbon) ribbon.style.transform = 'translateY(0)';
            if(header) {
                header.style.top = '2.5rem';
            }
        }
    });
});
